import React from "react";
import Slider from "react-slick";
import { TestimonialOneParams } from "../../utils/script";

let data = [
  {
    name: "Rekha Sharma",
    details:
      "I had a great experience with GlobalDreamz. My consultant guided me through the entire process, providing me with all the necessary details to pursue a master's degree in Canada. I am very satisfied with the support I receive from GlobalDreamz, and I would recommend it to other people.",
    designation: " ",
    image: "client-01.png",
  },
  {
    name: "Rishi Malhotra",
    details:
      "I would like to thank GlobalDreamz for playing a key role in making my dreams come true. My success on the exam was largely due to their unique teaching skills and splendid time management tips. They are highly experienced lecturers and will cover you from beginning to end.",
    designation: " ",
    image: "client-02.png",
  },
  {
    name: "Pratha Ahuja",
    details:
      "The team certainly helped me with the application process, from shortlisting universities that fit my profile, to improving my resume and SOP drafts, to reviewing my applications. It was a good decision for me to choose GlobalDreamz. - Pratha Ahuja",
    image: "client-03.png",
  },
  {
    name: "Rishi Malhotra",
    details:
      "I would like to thank GlobalDreamz for playing a key role in making my dreams come true. My success on the exam was largely due to their unique teaching skills and splendid time management tips. They are highly experienced lecturers and will cover you from beginning to end.",
    designation: " ",
    image: "client-04.png",
  },
];

const TestimonialOne = (props) => {
  const classes = `testimonial-activation testimonial-style-1 edu-slick-button slick-button-left ${
    props.className ? props.className : ""
  }`;
  data = props.item ? data.slice(0, props.item) : data;
  return (
    <Slider className={classes} {...TestimonialOneParams}>
      {data.map((item, i) => (
        <div className="single-testimonial" key={i}>
          <div className="inner">
            {props.quoteIcon !== "disable" && (
              <div className="quote-sign">
                <img
                  src={`${process.env.PUBLIC_URL}/images/testimonial/testimonial-01/quote.png`}
                  alt="Quote Images"
                />
              </div>
            )}
            <p className="description">“ {item.details}”</p>
            <div className="client-information">
              <div className="thumb">
                <img
                  src={`${process.env.PUBLIC_URL}/images/testimonial/testimonial-01/${item.image}`}
                  alt="Client Thumb"
                />
              </div>
              <div className="info">
                <h5 className="title">{item.name}</h5>
                <span className="designation">{item.designation}</span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </Slider>
  );
};
export default TestimonialOne;
